module.exports = __webpack_public_path__ + "media/images/icons/puzzle-piece-9a06d279a042f20e3320d59fa2bae5ae.svg";